import { inject, Injectable } from '@angular/core';

import { Task, TaskPriority, TaskResponse, TaskStatus, TaskType } from '../models/task.interface';
import { TaskMapperRegistry } from './task-mapper-registry.service';

@Injectable()
export class TaskAdapterService {
  private readonly mapperRegistry = inject(TaskMapperRegistry);

  toTask(r: TaskResponse): Task {
    const type = r.type ?? TaskType.Custom;
    return {
      id: r.id ?? '',
      name: r.name ?? '',
      description: r.description ?? '',
      status: r.status ?? TaskStatus.New,
      priority: r.priority ?? TaskPriority.Medium,
      type,
      assignee: {
        id: r.assigneeId ?? '',
        name: r.assigneeName ?? '',
      },
      data: this.mapperRegistry.map(type, r),
      createdAt: new Date(r.createdAt) ?? new Date(),
      resolution: r.resolution ?? '',
    };
  }
}
